// extracted by mini-css-extract-plugin
export var arrows = "_5h-5";
export var decrementer = "_5h-9";
export var disabled = "_5h-3";
export var error = "_5h-1";
export var hiddenText = "_5h-a";
export var incrementer = "_5h-8";
export var input = "_5h-7";
export var inputWrapper = "_5h-0";
export var readonly = "_5h-2";
export var regular = "_5h-6";
export var small = "_5h-4";